<template>
	<!--<v-img app :src="require('@/assets/test-bg.jpg')" :width="windowSize.width" :height="windowSize.height">-->
	<div :style="`width: ${windowSize.width}px; height: ${windowSize.height}px; background-color: #d9eef3;`">
		<v-container class="loginPage" background-color="secondary" fill-height justify-center>
			<v-col cols="12" sm="8" md="7" lg="6" xl="4" class="pb-12">
				<Login/>
			</v-col>
		</v-container>
	</div>
	<!--</v-img>-->
</template>

<script>

// ----------------------------------------------------
//
//  Main script
//
// ----------------------------------------------------

import Login from '@/components/attention/Login.vue';
import agile from '@/shift/agile';
export default
{
	name: 'LoginPage',

	components:
	{
		Login
	},

	data: () =>
	({
		windowSize: {
		width: 0,
		height: 0
		}
	}),

	created()
	{
		//this.onResize();
		this.boundOnResize = this.onResize.bind(this)
		window.addEventListener('resize', this.boundOnResize);

		// Flush values if user has relogged another user // Todo: This way to do it sucks
		agile.loggedInUser.uid = '';
		agile.loggedInUser.currentProject =
        {
            id: '',
            name: '',
            key: '',
            variable: '',
            accessMap: '',
            accessLevel: '',
            clientName: '',
            groupName: '',
            prettyName: '',

		};
		agile.loggedInUser.projects = [];
	},

	mounted()
	{
		this.onResize();
	},

	methods:
	{
		onResize()
		{
			this.windowSize.width = window.innerWidth;
			this.windowSize.height = window.innerHeight;
		}
	},

	beforeDestroy()
	{
		window.removeEventListener('resize', this.boundOnResize);
	},
}
</script>
